<nav id="sidebar2" >
    <div class="title" >
        <h4>MENÚ</h4>
    </div>
    <ul class="list-unstyled components mb-5">
        <li
          [routerLinkActive]="['active']"
          #rla="routerLinkActive" >
            <a [routerLink]="'/modulo-retencion/retencion'">
              <img src="../../../assets/images/general/folder.png" >&nbsp;&nbsp;&nbsp;&nbsp;Módulo Retención
            </a>
        </li>
        <div id="sidebar3" *ngIf="rla.isActive">
            <li
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{exact:true}"
              *ngxPermissionsOnly="['iniciativaMasiva']"
              (click)="selectedtab('iniciativa')">
                <a
                  style="margin-top: 5px !important;"
                  [routerLink]="'/modulo-retencion/retencion/iniciativa'">
                  <span class="iconsidebar3 icon-oval" style="width: 8px;height: 8px;"></span>&nbsp;&nbsp;&nbsp;&nbsp;Iniciativa masiva
                </a>
            </li>
            <li
              [routerLinkActive]="['active']"
              [routerLinkActiveOptions]="{exact:true}"
              *ngxPermissionsOnly="['reporteria']"
              (click)="selectedtab('reportes')">
                <a
                  style="margin-top: 5px !important;"
                  [routerLink]="'/modulo-retencion/retencion/reportes'">
                  <span class="iconsidebar3 icon-oval" style="width: 8px;height: 8px;"></span>&nbsp;&nbsp;&nbsp;&nbsp;Reportería
                </a>
            </li>
        </div>
    </ul>
</nav>

